import { PLUS_COURSE_DETAIL } from '@/constants';
import {
  sendBrazeLog,
  setAmplitudeUserProperty,
  setUtmTermToBraze,
} from '@/lib/utils/send-log';
import type { PlusCourseRoute } from '@/types';

function getCourseLogData(courseType: PlusCourseRoute) {
  const [courseTypeName, courseTitle] =
    PLUS_COURSE_DETAIL[courseType].koreanName.split(' ');

  return {
    course_title: courseTitle,
    course_type: courseTypeName,
  };
}

// 항해 플러스 지원 페이지 접속 시 발생 (브레이즈)
export function sendPlusApplyPageViewLogToBraze(courseType: PlusCourseRoute) {
  const logData = getCourseLogData(courseType);

  sendBrazeLog('hh_apply_page_view', logData);
  setUtmTermToBraze();
  setAmplitudeUserProperty('hh_funnel_stage', '지원서 작성중');
}

// 항해 지원 폼 제출 완료 시 발생 (브레이즈)
export function sendApplyFormSubmitCompletedLogToBraze(
  courseType: PlusCourseRoute,
  round: string,
) {
  const logData = {
    ...getCourseLogData(courseType),
    round,
  };

  sendBrazeLog('hh_apply_formSubmit_completed', logData);
  setUtmTermToBraze();
  setAmplitudeUserProperty('hh_funnel_stage', '지원서 제출');
}

// 항해 결제 완료 시 발생 (브레이즈)
export function sendPaymentPurchaseCompletedLogToBraze(
  courseType: PlusCourseRoute,
) {
  const logData = getCourseLogData(courseType);

  sendBrazeLog('hh_payment_purchase_completed', logData);
  setUtmTermToBraze();
  setAmplitudeUserProperty('hh_funnel_stage', '결제완료');
}

// 항해 허브 메인페이지 접속 시 발생 (브레이즈)
export function sendHubPageViewLogToBraze() {
  sendBrazeLog('hh_hub_page_view');
}
